$(function()
{
    $('form.automate input[type="text"]').attr('autocomplete', 'off');
    $(document).on("submit", "form.automate", function(e)
    {
        var fData = formData(this),
            url = fData.getUrl();
        if(!fData.getBool('isProcess') && !Web.isEmpty(url))
        {
            var frmData = $(this).serializeArray(),
                isValid = formValidators(this),
                status = $(this).find('.status'),
                btn = $(this).find("button[type=submit]:focus"),
                $btn = btn[0] ? btn : $(this).find('button[type="submit"]'),
                form = this;
                automateBtnLB = $btn.html(),
                errorHandle = handlingInternalErrors("INTERNET_CONNECTION"),
                beforeFn = $(this).data("before"),
                afterFn = $(this).data("after"),
                enableOverlay = $(this).data('overlay');
                
            var getFormInput = function(name)
            {
                for(var c in frmData)
                {
                    if(frmData[c].name == name)
                    {
                        return frmData[c].value;
                    }
                }
                return null;
            }, setFormInput = function(name, value)
            {
                for(var c in frmData)
                {
                    if(frmData[c].name == name)
                    {
                        frmData[c].value = value;
                        break;
                    }
                }
            }, overlayShow = function(enable)
            {
                if($("#wait-box")[0])
                {
                    if(enable)
                    {
                        $('#wait-box').fadeIn(400);
                        $('html,body').css({overflow: 'hidden'});
                    }
                    else
                    {
                        $('#wait-box').fadeOut(400);
                        $('html,body').css({overflow: 'auto'});
                    }
                }
            }, reloadRecaptcha = function()
            {
                // ::DISABLED:: No need to v3
                //if(typeof grecaptcha != "undefined") grecaptcha.reset();
            };
            
            //form
            var XHRRequest = function()
            {
                if(btn.attr("name") && btn.attr("value"))
                {
                    frmData[frmData.length] = {name: btn.attr("name"), value: btn.attr("value")};
                }
                if(errorHandle.status)
                {
                    isValid = false;
                    status.html(errorHandle.message);
                }
                if(isValid)
                {
                    fData.set("isProcess", "true");
                    status.html("").fadeOut(200);
                    $btn.html('Wait...').attr('disabled', 'disabled');
                    callFn(beforeFn);
                    disableForm(form, true);
                    $.ajax({
                        type: fData.getMethod(),
                        url: url,
                        data: frmData,
                        dataType: "json",
                        success: function (msg)
                        {
                            reloadRecaptcha();
                            fData.set("isProcess", "false");
                            disableForm(form);
                            isValid = true;
                            $btn.removeAttr('disabled');
                            $btn.html(automateBtnLB);
                            if(enableOverlay) overlayShow(false);

                            errorHandle = handlingInternalErrors("DB_SERVER_ERROR", msg);
                            if(errorHandle.status)
                            {
                                status.html(errorHandle.message).fadeIn(200);;
                                isValid = false;
                            }
                            if(isValid)
                            {
                                if(msg)
                                {
                                    if(msg['AlertError']) 
                                    {
                                        msg['msg'] = msg['AlertError'];
                                        msg['status'] = 0;
                                    }
                                    if(msg['AlertSuccess']) 
                                    {
                                        msg['msg'] = msg['AlertSuccess'];
                                        msg['status'] = 1;
                                    }

                                    if(msg['msg'])
                                    {
                                        status.html(bootstrapAlert(msg['msg'], msg['status'])).fadeIn(200);
                                    }
                                    if(msg['_call'])
                                    {
                                        var funName = msg['call'];
                                        if(pageActions[funName]) pageActions[funName].call(this, msg);
                                    }
                                    if(msg['_callback'])
                                    {
                                        var fnName = msg['callback'];
                                        if(!fnName.match(/[^a-z\_]/gi))
                                        {
                                            eval("if(" + fnName + " != 'undefined') " + fnName + ".call(this, msg);");
                                        }
                                    }
                                    if(msg['_clear'])
                                    {
                                        if(msg['clear'] == 'ALL')
                                        {
                                            form.reset();
                                        }
                                    }
                                    if(msg['_set'])
                                    {
                                        var dataCollection = msg['set'], setID;
                                        for(setID in dataCollection)
                                        {
                                            if(setID && dataCollection[setID])
                                            {
                                                $("#" + setID).val(dataCollection[setID]);
                                            }
                                        }
                                    }
                                    _actionHanlder(msg);
                                }
                            }
                            callFn(afterFn);
                        },
                        error: function (errormessage, statusText)
                        {
                            reloadRecaptcha();
                            if(enableOverlay) overlayShow(false);
                            errorHandle = handlingInternalErrors("AJAX_ERROR", statusText);
                            if(errorHandle.status)
                            {
                                status.html(errorHandle.message).fadeIn(200);
                                status.html();
                                fData.set("isProcess", "false");
                                disableForm(form);
                                $btn.removeAttr('disabled');
                                $btn.html(automateBtnLB);
                            }
                            callFn(afterFn);
                        }
                    });
                }
            };
            
            if(typeof grecaptcha != "undefined")
            {
                var recaptcha_v3_key = getFormInput("recaptcha_v3_key");
                var recaptcha_v3_action = getFormInput("recaptcha_v3_action");
                if(recaptcha_v3_key && recaptcha_v3_action && grecaptcha.ready)
                {
                    if(enableOverlay) overlayShow(true);
                    grecaptcha.execute(recaptcha_v3_key, {action: recaptcha_v3_action}).then(function(token)
                    {
                        setFormInput("recaptcha_v3_token", token);
                        XHRRequest();
                    });
                }
                else
                {
                    XHRRequest();
                }
            }
            else
            {
                XHRRequest();
            }
        }
        e.preventDefault();
    });
    var formData = function(formElement)
    {
        var _ = function() {}, $form = $(formElement);
        
        _.prototype.get = function(name)
        {
            return $form.data(name);
        }
        _.prototype.getBool = function(name)
        {
            return (this.get(name) == 'true')? true : false;
        }
        _.prototype.set = function(name, value)
        {
            $form.data(name, value);
        }
        _.prototype.is = function(name)
        {
            return !Web.isEmpty(this.get(name));
        }
        _.prototype.getUrl = function()
        {
            return $form.attr("action");
        }
        _.prototype.getMethod = function()
        {
            return $form.attr("method");
        }
        return new _();/*function()
        {
            this.get = function(name)
            {
                return $form.data(name);
            }
            this.getBool = function(name)
            {
                return (this.get(name) == 'true')? true : false;
            }
            this.set = function(name, value)
            {
                $form.data(name, value);
            }
            this.is = function(name)
            {
                return !Web.isEmpty(this.get(name));
            }
            this.getUrl = function()
            {
                return $(this).attr("action");
            }
            return this;
        };*/
    }
    
    function delConfirm(title)
    {
        return confirm(title || "Are you sure do you want to delete the item?")
    }
    
    $(document).on("submit", 'form.confirm-go-frm', function(e)
    {
        if(!delConfirm($(this).data("title")))
        {
            e.preventDefault();
        }
    }).on("click","a.xhr-delete-item", function(e)
    {
        var url = $(this).data("url");
        if(!url || url.length < 9)
        {
            e.preventDefault();
            return;
        }
        
        if(delConfirm($(this).data("title")))
        {
            var $this = $(this);
            _actionSpinner($this, true);
            $.ajax({
                type: "post",
                url: url,
                data: {_method: "DELETE"},
                dataType: "json",
                success: function(result)
                {
                    _actionSpinner($this, false);
                    _actionHanlder(result);
                }
            });
        }
        e.preventDefault();
    }).on("click", "a.xhr-request", function(e)
    {
        var prams = $(this).data(),
            url = prams.url || window.location.href,
            method = prams.method || "get";
        if(prams.url) delete prams.url;
        if(prams.method) delete prams.method;
        
        if(method == "patch")
        {
            prams['_method'] = "PATCH";
            method = "post";
        }
        else if(method == "delete")
        {
            prams['_method'] = "DELETE";
            method = "post";
        }
        var $this = $(this);
        _actionSpinner($this, true);
        $.ajax({
            type: method,
            url: url,
            data: prams,
            dataType: "json",
            success: function(result)
            {
                _actionSpinner($this, false);
                _actionHanlder(result);
            }
        });
        e.preventDefault();
    });
    function _actionHanlder(settings)
    {
        if(settings['_print']) window.open(settings['print'], '_blank');
        if(settings['_reload']) window.location.reload();
        if(settings['_goto']) window.location = settings['_goto'];
    }
    function _actionSpinner($elem, status)
    {
        if(status)
        {
            if($elem.find(".fa")[0]) $elem.find(".fa").addClass('fa-spinner fa-spin');
            else $elem.prepend('<span class="fa fa-spinner fa-spin fa-fw xhr-spin"></span>');
        }
        else
        {
            if($elem.find('.xhr-spin')[0]) $elem.find('.xhr-spin').remove();
            else $elem.find(".fa").removeClass('fa-spinner fa-spin');
        }
    }
});
var initFormValidation = false;
function formValidators(form, options)
{
    var cls, val, isValid = true, name;
    $(form).find('input,select,textarea').each(function()
    {
        cls = $(this).attr('class');
        name = $(this).attr('name');
        val = $(this).val();
        if(cls && cls.match(/required/g) && val == "")
        {
            $(this).addClass('empty');
            isValid = false;
        }
    });
	
    if(!initFormValidation)
    {
        initFormValidation = true;
        $(".empty").on('change', function()
        {
            $(this).removeClass('empty');
        })
    }
    return isValid;
}
function disableForm(form, option)
{
    if(!form) return ;
    var elem, type, defaultOption = true, d = 'disabled';
    if(!option) defaultOption = false;

    $(form).find('input[type="text"],input[type="email"],input[type="password"],select,textarea').each(function()
    {
        elem = $(this);
        type = elem.attr('type');
        if(type != 'hidden')
        {
                if(defaultOption) elem.attr(d, d);
                else elem.removeAttr(d);
        }
    });
}
var pageActions = {};
function handlingInternalErrors(handle, setting)
{
    var errRet = {status:false, message:"OK"};
    if(handle == "INTERNET_CONNECTION")
    {
        if(navigator.onLine === false) return {status:true, message:'<div class="alert alert-danger" role="alert"><strong>Warning!</strong> Could not connect to internet.</div>'};
    }
    else if(handle == "AJAX_ERROR")
    {
        //timeout, error, abort, parsererror
        if(setting == "parsererror") return {status:true, message:'<div class="alert alert-danger" role="alert"><b>Uncaught SyntaxError :</b><br> Please try again!</div>'};
        else return {status:true, message:'<div class="alert alert-danger" role="alert">Please try again!</div>'};
    }
    if(!setting) return errRet;
    if(setting.errorHandle)
    {
        if(handle == "DB_SERVER_ERROR")
        {
            errRet = {status:true, message:'<div class="alert alert-danger" role="alert">' + setting.message + '</div>'};
        }
    }
    return errRet;
}
function bootstrapAlert(msgText, status)
{
    var cls;
    switch(status)
    {
        case 0:
            cls = 'danger';
        break;
        case 1:
            cls = 'success';
        break;
        case 2:
            cls = 'warning';
        break;
        default:
            cls = 'info';
        break;
    }
    return '<div class="alert alert-' + cls + '" role="alert">' + msgText + '</div>';
}
function callFn(fn)
{
    if(fn && window[fn]) window[fn].call(this);
}

(function()
{
    $(document).ready(function()
    {
        $(document.body).append('<div class="modal fade" id="bs-modal-1"><form class="modal-dialog automate"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="modal-title"></h4></div><div class="modal-body"></div><div class="modal-footer"></div></div></form></div>');
    });
    window.modelWindow = model();
    function model()
    {
        var xhr, isSent, conData = {}, $m;
        $(document).on("click", ".mw-confirm-button", function()
        {
            isSent = true;
            $m.find(".modal-footer").hide();
            $m.find(".modal-body").html("Please wait...");
            xhr = $.post(JSON_URL, conData, function(data)
            {
                isSent = false;
                if(data && data["msg"] && data["status"] == "1")
                {
                    $m.find(".modal-body").html(bootstrapAlert(data["msg"], data["status"]));
                    if(data["goto"]) window.location = data["goto"];
                }
                else
                {
                    $m.find(".modal-footer").show();
                }
            });
        });
        
        return {
            open : function(options)
            {
                $m = $('#bs-modal-1');
                if(options.title) $m.find(".modal-title").html(options.title);
                $m.find(".modal-footer").css({display: "none"}).html("");
                $m.find(".modal-body").html('<div><div class="progress"><div class="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100" style="width: 100%"><span class="sr-only"></span>Please wait...</div></div></div>');
                if(options.width) $m.find(".modal-dialog").css({width: options.width, margin: "10px auto"});
                if(options.submit)
                {
                    var submit = '<button type="submit" class="btn btn-primary">Save changes</button>',
                        close = ' <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>';
                    if(options.close) submit = close + submit;
                    $m.find(".modal-footer").html(submit);
                }
                
                $m.modal("show");
                if(options.url)
                {
                    var data = {};
                    if(options.query) data = options.query;
                    
                    xhr = $.get(options.url, data, function(data)
                    {
                        if(data.modal)
                        {
                            $m.find(".modal-body").html(data.modal);
                            $m.find(".modal-footer").css({display: "block"});
                        }
                    });
                    $m.on('hide.bs.modal', function(e)
                    {
                        xhr && xhr.abort();
                    });
                }
            },
            confirm: function(options)
            {
                isSent = false;
                $m = $('#bs-modal-1');
                $m.find(".modal-title").html("Confrmation");
                if(options.content) $m.find(".modal-body").html(options.content);
                if(options.width) $m.find(".modal-dialog").css({width: options.width, margin: "10px auto"});
                
                var submit = '<button type="button" class="btn btn-success mw-confirm-button">Ok</button>',
                    close = ' <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>';
            
                $m.find(".modal-footer").html(submit + close).show();
                
                $m.modal("show");
                
                conData = {};
                if(options.query) conData = options.query;
                
                $m.on('hide.bs.modal', function(e)
                {
                    return !isSent;
                });
            }
        }
    }
})();
function wordCount(text)
{
    var count = 0,t = text.replace(/\n/g, " ");
    t = t.replace(/^\s/g, "");
    t = t.replace(/\s$/g, "");
    t = t.replace(/\s+$/g, " ");
    if(t != "")
    {
        count = t.split(" ").length;
    }
    return count;
}
function wordSlice(text, length)
{
     var t = text.replace(/\n/g, " |x|"), arr;
     
        t = t.replace(/^\s/g, "");
        t = t.replace(/\s$/g, "");
        t = t.replace(/\s+$/g, " ");
        newText = "",
        arr = t.split(" ");
    if(arr.length)
    {
        for(var i = 0; i < length; i++)
        {
            if(arr[i]) newText += arr[i] + " ";
        }
        newText = newText.replace(/\s\|x\|/g, "\n");
        newText = newText.replace(/\s$/g, "")
        
    }
    return newText;
}
if(typeof(isEmpty) == "undefined")
{
    function isEmpty(str)
    {
        return str == "" || str.length == 0;
    }
}
function currency(n)
{
    return n == "" ? '0.00' : parseFloat(n).toFixed(2);
}
function URLCompressor(str)
{
    var v = str;
    v = v.toLowerCase();
    v = v.replace(/[\s\,\/\?\:\@\&\=\+\$\#\(\)\'\’\"]/g, "-");
    v = v.replace(/[\-]+/g, "-");
    v = v.replace(/^\-/g, "");
    v = v.replace(/\-$/g, "");
    v = escape(v);
	return v;
}
(function()
{
    var _id = 1, modID = "#notification-module", isRunning = false;
    $(document).ready(function()
    {
        $(document.body).append('<div id="notification-module"></div>');
        $(modID).hide();
    });
    window.notify = model();
    function model()
    {
        var xhr, isSent, conData = {}, $m;
        $(document).on("click", ".mw-confirm-button", function()
        {
            isSent = true;
            $m.find(".modal-footer").hide();
            $m.find(".modal-body").html("Please wait...");
            xhr = $.post(JSON_URL, conData, function(data)
            {
                isSent = false;
                if(data && data["msg"] && data["status"] == "1")
                {
                    $m.find(".modal-body").html(bootstrapAlert(data["msg"], data["status"]));
                    if(data["goto"]) window.location = data["goto"];
                }
                else
                {
                    $m.find(".modal-footer").show();
                }
            });
        });
        window.onbeforeunload = function()
        {
            if(isRunning) return 'Are you sure you want to leave?';
        } 
        return {
            show : function(text)
            {
                var eid = 'notify-' + _id;
                this.id = eid;
                this.message = function(text)
                {
                    isRunning = false;
                    $("#" + this.id).html(text);
                };
                $(modID).prepend('<div class="notify" id="' + eid + '">' + text + '</div>').show();
                $("#" + eid).fadeIn(200);
                _id++;
                isRunning = true;
                return this;
            },
            hide : function(ref)
            {
                $("#" + ref).fadeOut(200, function()
                {
                    if($(modID).html() == "")
                    {
                        $(modID).hide();
                        isRunning = false;
                    }
                });
            },
            ignore: function()
            {
                isRunning = false;
            }
        }
    }
})();

var Web = {
    isEmpty : function(str)
    {
        return str == "" || str == null || str == 'undefined';
    }
}, FindBox = function(options)
{
    var $panel, $form, xhr, isAbort, formUrl, formMethod = "get", frmData = {};
    this.go = function(opt)
    {
        fetchForm();
        wait();
        xhr = $.ajax({
            url : (opt && opt.url ? opt.url : formUrl),
            type : formMethod,
            dataType: "json",
            data : frmData,
            error : retry,
            success : result
        });
    }
    if(options.form)
    {
        if(options.form[0]) $form = options.form;
    }
    if(options.panel)
    {
        $panel = options.panel;
        var obj = this;
        $(document).on("click", ".xhr-retry", this.go);
        $(document).on("click", ".pagination a", function(e)
        {
            var u = $(this).attr("href");
            if(u) obj.go({url : u});
            e.preventDefault();
        });
    }
    
    var retry = function()
    {
        status('<button class="btn btn-normal xhr-retry"><span class="glyphicon glyphicon-repeat"></span> Click to Retry</button>');
    }, wait = function()
    {
        status('<div class="css-loader">Loading...</div>');
    }, result = function(data)
    {
        
        if(data && data["table"] && data["table"]['rows'].length > 0)
        {
            var i, $table, link,
                rows = data["table"]["rows"],
                format = data["table"]["format"],
                set = data["set"];
        
            $table = $panel.find("table.table tbody");
            $panel.find(".panel-footer").hide();
            $panel.find(".table").fadeOut();
            $table.html("");
            for(i in rows)
            {
                $table.append(sprintf(format, rows[i]));
            }
            if(set && set["footer"])
            {
                $panel.find(".box-footer").show().html(set["footer"]);
            }
            $panel.find(".table").fadeIn(500);
            $panel.find(".box-body").hide();
        }
        else
        {
            noResult();
        }
    }, noResult = function()
    {
        status('<p class="text-center">No Record.</p>');
    }, status = function(msg)
    {
        $panel.find(".box-footer").hide();
        $panel.find(".table tbody tr").hide(400, function()
        {
            $(this).remove();
        });
        $panel.find(".box-body").show().html('<div class="status-msg">' + msg + '</div>');
    }, fetchForm = function()
    {
        formUrl = $form.attr("action");
        formMethod = $form.attr("method") == "post" ? "post" : "get";
        frmData = $form.serializeArray();
    }, sprintf = function(format, params)
    {
        var i = -1;
        return format.replace(/\{([\d]+)\}/g, function(match, m)
        {
            i++;
            return params[i] ? params[i] : "";
        });
    };
    
    return this;
};;
(function()
{
    var _class = function() { return this;},
        _$btn, _$field, _isShown = false,
        _icon = function(shown)
        {
            return '<span class="glyphicon glyphicon-eye-' + (shown ? "close" : "open") + '" aria-hidden="true"></span>';
        },
        _genPassword = function(len)
        {
            var alphaSmall = "abcdefghijklmnopqrstuvwxyz",
                alphaCaps = "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
                numbers = "0123456789",
                symbol = "!@#$^*()+[]{}:;?,.'_+=-",
                chars = alphaSmall + alphaCaps + numbers + symbol,
                i = 0, word = "", max = chars.length;
            
            while(len && i < len)
            {
                word += chars.substr(_randNumber(max), 1);
                i++;
            }
            return word;
        },
        _randNumber = function(max)
        {
            return Math.round(Math.random() * max);
        };
        
    _class.prototype.show = function()
    {
        if(_$btn) _$btn.html(_icon(true));
        if(_$field) _$field.attr("type", "text");
        _isShown = true;
    }
    _class.prototype.hide = function()
    {
        if(_$btn) _$btn.html(_icon(false));
        if(_$field) _$field.attr("type", "password");
        _isShown = false;
    }
    _class.prototype.generate = function()
    {
        this.show();
        var pass = _genPassword(12);
        if(_$field) _$field.val(pass);
        return pass;
    }
    _class.prototype.reset = function()
    {
        this.hide();
        if(_$field)_$field.val("");
    }
    _class.prototype.toggle = function()
    {
        if(_isShown) this.hide();
        else this.show();
    }
    $(document).ready(function()
    {
        _$btn = $("#psw-group button");
        _$field = $("#password");
            
        PassField.reset();
        $("#psw-group button").on("click", function()
        {
            PassField.toggle();
        });
    })
    window["PassField"] = new _class();
}).call(this);
var MD5Hash = function(e) {
    function h(a, b) {
        var c, d, e, f, g;
        e = a & 2147483648;
        f = b & 2147483648;
        c = a & 1073741824;
        d = b & 1073741824;
        g = (a & 1073741823) + (b & 1073741823);
        return c & d ? g ^ 2147483648 ^ e ^ f : c | d ? g & 1073741824 ? g ^ 3221225472 ^ e ^ f : g ^ 1073741824 ^ e ^ f : g ^ e ^ f
    }

    function k(a, b, c, d, e, f, g) {
        a = h(a, h(h(b & c | ~b & d, e), g));
        return h(a << f | a >>> 32 - f, b)
    }

    function l(a, b, c, d, e, f, g) {
        a = h(a, h(h(b & d | c & ~d, e), g));
        return h(a << f | a >>> 32 - f, b)
    }

    function m(a, b, d, c, e, f, g) {
        a = h(a, h(h(b ^ d ^ c, e), g));
        return h(a << f | a >>> 32 - f, b)
    }

    function n(a, b, d, c, e, f, g) {
        a = h(a, h(h(d ^ (b | ~c), e), g));
        return h(a << f | a >>> 32 - f, b)
    }

    function p(a) {
        var b = "",
            d = "",
            c;
        for (c = 0; 3 >= c; c++) d = a >>> 8 * c & 255, d = "0" + d.toString(16), b += d.substr(d.length - 2, 2);
        return b
    }
    var f = [],
        q, r, s, t, a, b, c, d;
    e = function(a) {
        a = a.replace(/\r\n/g, "\n");
        for (var b = "", d = 0; d < a.length; d++) {
            var c = a.charCodeAt(d);
            128 > c ? b += String.fromCharCode(c) : (127 < c && 2048 > c ? b += String.fromCharCode(c >> 6 | 192) : (b += String.fromCharCode(c >> 12 | 224), b += String.fromCharCode(c >> 6 & 63 | 128)), b += String.fromCharCode(c & 63 | 128))
        }
        return b
    }(e);
    f = function(b) {
        var a, c = b.length;
        a = c + 8;
        for (var d = 16 * ((a - a % 64) / 64 + 1), e = Array(d - 1), f = 0, g = 0; g < c;) a = (g - g % 4) / 4, f = g % 4 * 8, e[a] |= b.charCodeAt(g) << f, g++;
        a = (g - g % 4) / 4;
        e[a] |= 128 << g % 4 * 8;
        e[d - 2] = c << 3;
        e[d - 1] = c >>> 29;
        return e
    }(e);
    a = 1732584193;
    b = 4023233417;
    c = 2562383102;
    d = 271733878;
    for (e = 0; e < f.length; e += 16) q = a, r = b, s = c, t = d, a = k(a, b, c, d, f[e + 0], 7, 3614090360), d = k(d, a, b, c, f[e + 1], 12, 3905402710), c = k(c, d, a, b, f[e + 2], 17, 606105819), b = k(b, c, d, a, f[e + 3], 22, 3250441966), a = k(a, b, c, d, f[e + 4], 7, 4118548399), d = k(d, a, b, c, f[e + 5], 12, 1200080426), c = k(c, d, a, b, f[e + 6], 17, 2821735955), b = k(b, c, d, a, f[e + 7], 22, 4249261313), a = k(a, b, c, d, f[e + 8], 7, 1770035416), d = k(d, a, b, c, f[e + 9], 12, 2336552879), c = k(c, d, a, b, f[e + 10], 17, 4294925233), b = k(b, c, d, a, f[e + 11], 22, 2304563134), a = k(a, b, c, d, f[e + 12], 7, 1804603682), d = k(d, a, b, c, f[e + 13], 12, 4254626195), c = k(c, d, a, b, f[e + 14], 17, 2792965006), b = k(b, c, d, a, f[e + 15], 22, 1236535329), a = l(a, b, c, d, f[e + 1], 5, 4129170786), d = l(d, a, b, c, f[e + 6], 9, 3225465664), c = l(c, d, a, b, f[e + 11], 14, 643717713), b = l(b, c, d, a, f[e + 0], 20, 3921069994), a = l(a, b, c, d, f[e + 5], 5, 3593408605), d = l(d, a, b, c, f[e + 10], 9, 38016083), c = l(c, d, a, b, f[e + 15], 14, 3634488961), b = l(b, c, d, a, f[e + 4], 20, 3889429448), a = l(a, b, c, d, f[e + 9], 5, 568446438), d = l(d, a, b, c, f[e + 14], 9, 3275163606), c = l(c, d, a, b, f[e + 3], 14, 4107603335), b = l(b, c, d, a, f[e + 8], 20, 1163531501), a = l(a, b, c, d, f[e + 13], 5, 2850285829), d = l(d, a, b, c, f[e + 2], 9, 4243563512), c = l(c, d, a, b, f[e + 7], 14, 1735328473), b = l(b, c, d, a, f[e + 12], 20, 2368359562), a = m(a, b, c, d, f[e + 5], 4, 4294588738), d = m(d, a, b, c, f[e + 8], 11, 2272392833), c = m(c, d, a, b, f[e + 11], 16, 1839030562), b = m(b, c, d, a, f[e + 14], 23, 4259657740), a = m(a, b, c, d, f[e + 1], 4, 2763975236), d = m(d, a, b, c, f[e + 4], 11, 1272893353), c = m(c, d, a, b, f[e + 7], 16, 4139469664), b = m(b, c, d, a, f[e + 10], 23, 3200236656), a = m(a, b, c, d, f[e + 13], 4, 681279174), d = m(d, a, b, c, f[e + 0], 11, 3936430074), c = m(c, d, a, b, f[e + 3], 16, 3572445317), b = m(b, c, d, a, f[e + 6], 23, 76029189), a = m(a, b, c, d, f[e + 9], 4, 3654602809), d = m(d, a, b, c, f[e + 12], 11, 3873151461), c = m(c, d, a, b, f[e + 15], 16, 530742520), b = m(b, c, d, a, f[e + 2], 23, 3299628645), a = n(a, b, c, d, f[e + 0], 6, 4096336452), d = n(d, a, b, c, f[e + 7], 10, 1126891415), c = n(c, d, a, b, f[e + 14], 15, 2878612391), b = n(b, c, d, a, f[e + 5], 21, 4237533241), a = n(a, b, c, d, f[e + 12], 6, 1700485571), d = n(d, a, b, c, f[e + 3], 10, 2399980690), c = n(c, d, a, b, f[e + 10], 15, 4293915773), b = n(b, c, d, a, f[e + 1], 21, 2240044497), a = n(a, b, c, d, f[e + 8], 6, 1873313359), d = n(d, a, b, c, f[e + 15], 10, 4264355552), c = n(c, d, a, b, f[e + 6], 15, 2734768916), b = n(b, c, d, a, f[e + 13], 21, 1309151649), a = n(a, b, c, d, f[e + 4], 6, 4149444226), d = n(d, a, b, c, f[e + 11], 10, 3174756917), c = n(c, d, a, b, f[e + 2], 15, 718787259), b = n(b, c, d, a, f[e + 9], 21, 3951481745), a = h(a, q), b = h(b, r), c = h(c, s), d = h(d, t);
    return (p(a) + p(b) + p(c) + p(d)).toLowerCase()
};
function debugForm(selector, setter)
{
    var key = '_debug_form_' + MD5Hash(selector);
    if(!setter)
    {
        var data = JSON.stringify($(selector).serializeArray());
        window.localStorage.setItem(key, data);
        return data;
    }
    else if(setter == "reset")
    {
        $(selector)[0].reset()
    }
    else
    {
        var data = JSON.parse(window.localStorage.getItem(key));
        $(data).each(function(index, key)
        {
            
            if($(selector).find('select[name="' + key.name + '"]').length)
            {
                $(selector).find('select[name="' + key.name + '"]').val(key.value);
            }
            else if($(selector).find('textarea[name="' + key.name + '"]').length)
            {
                $(selector).find('textarea[name="' + key.name + '"]').val(key.value);
            }
            else if($(selector).find('input[name="' + key.name + '"]').length)
            {
                $(selector).find('input[name="' + key.name + '"]').val(key.value);
            }
        });
    }
}